export default {
  'financialAdministration.title': 'Financial administration',
  'financialAdministration.description':
    'Customer payments, commission obligations and settlements for the commercial hub.',
  'financialAdministration.tabs.overview': 'Overview',
  'financialAdministration.tabs.payments': 'Payments',
  'financialAdministration.tabs.ledgers': 'Commission obligations',
  'financialAdministration.tabs.settlements': 'Settlements',
  'financialAdministration.tabs.beneficiary': 'Beneficiary history',
  'financialAdministration.filters.currency': 'Currency',
  'financialAdministration.filters.apply': 'Apply',
  'financialAdministration.filters.clear': 'Clear',
  'financialAdministration.filters.dateRange': 'Date range',
  'financialAdministration.filters.saleRange': 'Sale date',
  'financialAdministration.filters.eligibilityRange': 'Eligibility date',
  'financialAdministration.filters.paymentRange': 'Effective payment date',
  'financialAdministration.filters.generatedRange': 'Generated',
  'financialAdministration.filters.paidRange': 'Paid at',
  'financialAdministration.filters.companyId': 'Paying company id',
  'financialAdministration.filters.subscriptionId': 'Subscription id',
  'financialAdministration.filters.provider': 'Provider',
  'financialAdministration.filters.status': 'Status',
  'financialAdministration.filters.discounted': 'Discounted',
  'financialAdministration.filters.discounted.true': 'With discount',
  'financialAdministration.filters.discounted.false': 'Without discount',
  'financialAdministration.filters.beneficiaryCompanyId': 'Beneficiary company id',
  'financialAdministration.filters.beneficiaryActorKind': 'Beneficiary kind',
  'financialAdministration.filters.agreementId': 'Agreement id',
  'financialAdministration.filters.revenueType': 'Revenue type',
  'financialAdministration.filters.derivedState': 'Derived state',
  'financialAdministration.filters.paymentDisposition': 'Payment disposition',
  'financialAdministration.filters.settlementId': 'Settlement id',
  'financialAdministration.filters.ruleFrequency': 'Rule frequency',
  'financialAdministration.error.dates': 'From must be earlier than to (UTC, half-open).',
  'financialAdministration.error.page': 'Invalid page size.',
  'financialAdministration.error.missingBeneficiary': 'Enter a beneficiary company id.',
  'financialAdministration.overview.axis.payment': 'Confirmed payments (effective payment date)',
  'financialAdministration.overview.axis.saleGenerated':
    'Commission generated and omitted (sale date)',
  'financialAdministration.overview.axis.eligibility': 'Due / eligible (eligibility date)',
  'financialAdministration.overview.axis.settlementOpen': 'Open settlements (generated at)',
  'financialAdministration.overview.axis.settlementPaid': 'Paid settlements (paid at)',
  'financialAdministration.overview.axis.inconsistent': 'Inconsistent rows (sale date)',
  'financialAdministration.overview.confirmedNetAmount': 'Confirmed net',
  'financialAdministration.overview.grossAmount': 'Gross',
  'financialAdministration.overview.taxAmount': 'Tax',
  'financialAdministration.overview.discountAmount': 'Discount',
  'financialAdministration.overview.commissionGeneratedGross': 'Commission generated',
  'financialAdministration.overview.omittedCommissionGross': 'Omitted',
  'financialAdministration.overview.notYetDue': 'Not yet due',
  'financialAdministration.overview.duePendingApproval': 'Due, pending approval',
  'financialAdministration.overview.eligibleUnsettledGross': 'Eligible, unsettled',
  'financialAdministration.overview.inSettlementGross': 'In settlement',
  'financialAdministration.overview.paidCommissionGross': 'Paid commission',
  'financialAdministration.overview.openSettlementGross': 'Open settlement gross',
  'financialAdministration.overview.openSettlementAdjustments': 'Open settlement adjustments',
  'financialAdministration.overview.settlementNetPayable': 'Open net payable',
  'financialAdministration.overview.paidSettlementGross': 'Paid settlement gross',
  'financialAdministration.overview.paidSettlementAdjustments': 'Paid settlement adjustments',
  'financialAdministration.overview.paidNetPayable': 'Paid net payable',
  'financialAdministration.overview.inconsistentCount': 'Inconsistent count',
  'financialAdministration.overview.inconsistentAmount': 'Inconsistent amount',
  'financialAdministration.derivedState.notYetDue': 'Not yet due',
  'financialAdministration.derivedState.duePendingApproval': 'Due, pending approval',
  'financialAdministration.derivedState.eligibleUnsettled': 'Eligible, unsettled',
  'financialAdministration.derivedState.inSettlement': 'In settlement',
  'financialAdministration.derivedState.paid': 'Paid',
  'financialAdministration.derivedState.omitted': 'Omitted (actor suspended)',
  'financialAdministration.derivedState.cancelled': 'Cancelled',
  'financialAdministration.derivedState.reversed': 'Reversed',
  'financialAdministration.derivedState.inconsistent': 'Inconsistent',
  'financialAdministration.paymentDisposition.payable': 'Payable',
  'financialAdministration.paymentDisposition.omittedActorSuspended': 'Omitted — actor suspended',
  'financialAdministration.ledgerStatus.pending': 'Pending',
  'financialAdministration.ledgerStatus.approved': 'Approved',
  'financialAdministration.ledgerStatus.settled': 'Settled',
  'financialAdministration.ledgerStatus.paid': 'Paid',
  'financialAdministration.ledgerStatus.cancelled': 'Cancelled',
  'financialAdministration.ledgerStatus.reversed': 'Reversed',
  'financialAdministration.settlementStatus.draft': 'Draft',
  'financialAdministration.settlementStatus.pendingReview': 'Pending review',
  'financialAdministration.settlementStatus.approved': 'Approved',
  'financialAdministration.settlementStatus.paid': 'Paid',
  'financialAdministration.settlementStatus.cancelled': 'Cancelled',
  'financialAdministration.columns.id': 'Id',
  'financialAdministration.columns.companyId': 'Company',
  'financialAdministration.columns.subscriptionId': 'Subscription',
  'financialAdministration.columns.provider': 'Provider',
  'financialAdministration.columns.status': 'Status',
  'financialAdministration.columns.currency': 'Currency',
  'financialAdministration.columns.effectivePaymentDate': 'Effective payment',
  'financialAdministration.columns.billingPeriod': 'Billing period',
  'financialAdministration.columns.baseNetAmount': 'Base',
  'financialAdministration.columns.discountAmount': 'Discount',
  'financialAdministration.columns.netAmount': 'Net',
  'financialAdministration.columns.taxAmount': 'Tax',
  'financialAdministration.columns.grossAmount': 'Gross',
  'financialAdministration.columns.mrrAmount': 'MRR',
  'financialAdministration.columns.derivedState': 'Derived state',
  'financialAdministration.columns.ruleFrequencyType': 'Frequency',
  'financialAdministration.columns.beneficiary': 'Beneficiary',
  'financialAdministration.columns.customer': 'Customer',
  'financialAdministration.columns.agreement': 'Agreement',
  'financialAdministration.columns.revenueType': 'Revenue',
  'financialAdministration.columns.commissionAmount': 'Commission',
  'financialAdministration.columns.effectiveSaleDate': 'Sale date',
  'financialAdministration.columns.eligibilityDate': 'Eligibility',
  'financialAdministration.columns.settlementId': 'Settlement',
  'financialAdministration.columns.generatedAt': 'Generated',
  'financialAdministration.columns.paidAt': 'Paid at',
  'financialAdministration.columns.period': 'Period',
  'financialAdministration.columns.grossCommissionAmount': 'Gross commission',
  'financialAdministration.columns.adjustmentsAmount': 'Adjustments',
  'financialAdministration.columns.netPayableAmount': 'Net payable',
  'financialAdministration.columns.settlementFrequency': 'Frequency',
  'financialAdministration.columns.commissionLedgerId': 'Obligation',
  'financialAdministration.columns.adjustmentAmount': 'Adjustment',
  'financialAdministration.columns.finalAmount': 'Final',
  'financialAdministration.detail.payment': 'Payment',
  'configForm.hero.summary.resource.financialAdministrationPayment.details': 'payment',
  'configForm.hero.summary.resource.financialAdministrationLedger.details': 'obligation',
  'configForm.hero.summary.resource.financialAdministrationSettlement.details': 'settlement',
  'financialAdministration.detail.openBeneficiary': 'Beneficiary history',
  'financialAdministration.detail.resolutionTrace': 'Resolution trace',
  'financialAdministration.detail.items': 'Settlement lines',
  'financialAdministration.detail.itemsSummary': 'Stored lines of the selected settlement.',
  'financialAdministration.detail.discountAssignment': 'Discount assignment',
  'financialAdministration.detail.discountAgreement': 'Discount template',
  'financialAdministration.detail.discountLoading': 'Loading discount…',
  'financialAdministration.detail.discountMissing': 'The stored discount assignment was not found.',
  'financialAdministration.detail.paymentDisposition': 'Payment disposition',
  'financialAdministration.detail.ledgerStatus': 'Ledger status',
  'financialAdministration.beneficiary.totals': 'Commission totals',
  'financialAdministration.beneficiary.ledgers': 'Obligations',
  'financialAdministration.beneficiary.settlements': 'Settlements',
  'financialAdministration.beneficiary.load': 'Load history',
  'financialAdministration.beneficiary.commissionGenerated': 'Commission generated',
  'financialAdministration.beneficiary.notYetDue': 'Not yet due',
  'financialAdministration.beneficiary.duePendingApproval': 'Due, pending approval',
  'financialAdministration.beneficiary.eligibleUnsettled': 'Eligible, unsettled',
  'financialAdministration.beneficiary.inSettlement': 'In settlement',
  'financialAdministration.beneficiary.paidCommission': 'Paid commission',
  'financialAdministration.beneficiary.omitted': 'Omitted',
  'financialAdministration.beneficiary.openSettlementGross': 'Open settlement gross',
  'financialAdministration.beneficiary.openSettlementAdjustments': 'Open settlement adjustments',
  'financialAdministration.beneficiary.openSettlementNetPayable': 'Open net payable',
  'financialAdministration.beneficiary.paidSettlementGross': 'Paid settlement gross',
  'financialAdministration.beneficiary.paidSettlementAdjustments': 'Paid settlement adjustments',
  'financialAdministration.beneficiary.paidNetPayable': 'Paid net payable',
  'financialAdministration.ruleFrequency.recurring': 'Recurring',
  'financialAdministration.ruleFrequency.oneTime': 'One-time',
  'financialAdministration.ruleFrequency.empty': '—',
  'financialAdministration.provider.stripe': 'Stripe',
  'financialAdministration.provider.bankTransfer': 'Bank transfer',
  'financialAdministration.provider.manual': 'Manual',
  'financialAdministration.paymentStatus.pending': 'Pending',
  'financialAdministration.paymentStatus.requiresAction': 'Requires action',
  'financialAdministration.paymentStatus.processing': 'Processing',
  'financialAdministration.paymentStatus.paid': 'Paid',
  'financialAdministration.paymentStatus.failed': 'Failed',
  'financialAdministration.paymentStatus.cancelled': 'Cancelled',
  'financialAdministration.paymentStatus.refunded': 'Refunded',
  'financialAdministration.paymentStatus.partiallyRefunded': 'Partially refunded',
};
